import template from "./hb-footer.mjs";
import { render } from "lit-html";
import { User } from "firebase/auth";

import { HbLogin } from "../hb-footer/hb-login/hb-login.ts";
import { HbSignin } from "../hb-footer/hb-signin/hb-signin.ts";
import { HbHumanity } from "./hb-humanity/hb-humanity.ts";
import { HbPhone } from "./hb-phone/hb-phone.ts";
import { HbFeatures } from "./hb-features/hb-features.ts";
import { HbAbout } from "./hb-about/hb-about.ts";
import { HbTabBar } from "./hb-tabbar/hb-tabbar.ts";

customElements.define("hb-login", HbLogin);
customElements.define("hb-signin", HbSignin);
customElements.define("hb-humanity", HbHumanity);
customElements.define("hb-phone", HbPhone);
customElements.define("hb-features", HbFeatures);
customElements.define("hb-about", HbAbout);
customElements.define("hb-tabbar", HbTabBar);

// import { HbAccount } from "./hb-humanity/hb-account/hb-account.ts";
// import { HbMithril } from "./hb-humanity/hb-mithril/hb-mithril.ts";
// customElements.define("hb-account", HbAccount);
// customElements.define("hb-mithril", HbMithril);

export class HbFooter extends HTMLElement {
    private login: HbLogin;
    private signin: HbSignin;
    private humanity: HbHumanity;
    private phone: HbPhone;
    private features: HbFeatures;
    private about: HbAbout;
    private tabBar: HbTabBar;

    constructor() {
        super();
        render(template(null), this);

        this.login = this.querySelector("hb-login")!;
        this.signin = this.querySelector("hb-signin")!;
        this.humanity = this.querySelector("hb-humanity")!;
        this.phone = this.querySelector("hb-phone")!;
        this.features = this.querySelector("hb-features")!;
        this.about = this.querySelector("hb-about")!;
        this.tabBar = this.querySelector("hb-tabbar")!;
    }

    showLogin() {
        this.login.show();
    }

    hideLogin() {
        this.login.hide();
    }

    showSignin() {
        this.signin.show();
    }

    hideSignin() {
        this.signin.hide();
    }

    showHumanity(page: string) {
        this.humanity.show(page);
    }

    hideHumanity() {
        this.humanity.hide();
    }

    renderHumanity(user: User | null) {
        this.humanity.render(user);
    }

    showPhone() {
        this.phone.show();
    }

    hidePhone() {
        this.phone.hide();
    }

    showFeatures() {
        this.features.show();
    }

    hideFeatures() {
        this.features.hide();
    }

    showAbout(page: string) {
        this.about.show(page);
    }

    hideAbout() {
        this.about.hide();
    }

    showTabBar() {
        this.tabBar.show();
    }

    hideTabBar() {
        this.tabBar.hide();
    }
}
